require("!!/code/frontend/node_modules/script-loader/addScript.js")(require("!!/code/frontend/node_modules/raw-loader/index.js!/code/frontend/node_modules/grapesjs/dist/grapes.js"))


//////////////////
// WEBPACK FOOTER
// /code/frontend/~/script-loader!/code/frontend/~/grapesjs/dist/grapes.js
// module id = ../../../../script-loader/index.js!../../../../grapesjs/dist/grapes.js
// module chunks = 3